import { Component, OnInit, Input, SimpleChanges, ViewChild, Renderer2, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TimeSeriesDetail } from 'src/app/models/dashboard';
import { ElapsedTimeService } from '../../../service/elapsed-time.service';

interface PreviousLightStackElement {
  key: string;
  element: Element;
}

@Component({
  selector: 'app-image-overlay',
  templateUrl: './image-overlay.component.html',
  styleUrls: ['./image-overlay.component.css']
})
export class ImageOverlayComponent implements OnInit, AfterViewInit {
  @ViewChild('sourceImage') sourceImage;
  
  @Input() overlayConfig: any;
  @Input() imageUrl: string;
  @Input() imageData: string;
  @Input() allowPointSelection: boolean;
  @Input() itemPos: number;

  @Output() objectSelected = new EventEmitter<any>();

  public showImg: boolean = true;

  ranges: any[] = [];
  colourRangeType: any[] = ['danger', 'default', 'info', 'primary', 'success', 'warning'];
  imageRef:any;
  imageRefTarget:any;
  lightStackPosMap = new Map();
  previousLightStackEleMap = new Map();
  overlayLightMap = new Map();
  overlayLightCounter:number = 0;

  showDashboardId: number;

  constructor(private renderer:Renderer2, private elapsedTimeService:ElapsedTimeService) {
    
  }


  public updateTSData(overlay: any){
    const stackContainerElement = this.getStackContainerElement(overlay.uri); 
    
    const isLightStack = overlay.displayOption == 'light-stack' ? true : false;
    const isActiveLight = overlay.displayOption == 'dot' ? true : false;

    // if overlay config is string, then convert to objects
    if (typeof this.overlayConfig === 'string' || this.overlayConfig instanceof String){
      this.overlayConfig = JSON.parse(this.overlayConfig.toString());
    }
    //console.log(this.overlayConfig);

    if(isLightStack || isActiveLight){
      //Keep this light stack repositioning code for now
      // const imgRect = this.sourceImage.nativeElement.getBoundingClientRect();
      // if(!this.hasLightStackRepositioned(overlay.uri)){
      //   this.repositionLightStack(stackContainerElement, imgRect);  
      // }

      for (let i = 0; i < this.overlayConfig.length; i++) {
        
        const item = this.overlayConfig[i];
        if(overlay.uri == item.uri){
          this.updateLights(i, overlay, stackContainerElement);
          break;
        }
      }
    }
  }

  private updateLightStack(pos, overlay:any, element:HTMLElement){
    for (var i = 0, keys = Object.keys(overlay), ii = keys.length; i < ii; i++) {
      var key = keys[i];
      var range = overlay[key];
      if (range && range.min && range.max){
        //within range
        if (overlay.value >= range.min  && overlay.value <= range.max) {
          //clean up if animination was assigned to a light other than the current one
          const previousElement = <PreviousLightStackElement> this.previousLightStackEleMap.get(pos);
          
          if(previousElement?.key!=null && previousElement?.key!=key){
            this.renderer.removeClass(previousElement.element, `animated-lightstack-${previousElement.key}`);
          }
          
          const targetEleGroup = element.getElementsByClassName(`light-stack-${key}`);
          if(targetEleGroup.length > 0){
              const targetEle = targetEleGroup[0];
              const previousEle: PreviousLightStackElement = {
                key: key,
                element: targetEle
            }
            this.previousLightStackEleMap.set(pos, previousEle);

            const isAniamted = targetEle.classList.value.includes('animated');

            if(isAniamted){
              this.renderer.removeClass(targetEle, `animated-lightstack-${key}`);
              void element.offsetWidth;
              this.renderer.addClass(targetEle, `animated-lightstack-${key}`);
            }
            else
              this.renderer.addClass(targetEle, `animated-lightstack-${key}`);
           }else{
             console.error('Lightstack element not found!');
           }
          }
      }
    }
  }

  private updateActiveLight(pos, overlay:any, element:HTMLElement){
    //console.log(`Update active light: ${overlay.name} ${overlay.min} ${overlay.max}`);
    for (var i = 0, keys = Object.keys(overlay), ii = keys.length; i < ii; i++) {
      var key = keys[i];
      var range = overlay[key];
      if (range && range.min != null && range.max != null){
        //within range
        if (overlay.value >= range.min  && overlay.value <= range.max) {
          //clean up if animination was assigned to a light other than the current one
          const previousElement = <PreviousLightStackElement> this.previousLightStackEleMap.get(pos);
          
          if(previousElement?.key!=null && previousElement?.key!=key){
            this.renderer.removeClass(previousElement.element, `animated-lightstack-${previousElement.key}`);
          }
          
          const activeLightElement = element.querySelector("[isFirstTime]");
          const isFirstTime = JSON.parse(activeLightElement.getAttribute('isFirstTime'));
          if(isFirstTime){
            activeLightElement.setAttribute('isFirstTime', 'false');
          }

          this.previousLightStackEleMap.set(pos, activeLightElement);

          const isAniamted = activeLightElement.classList.value.includes('animated');

          if(isAniamted){
            this.renderer.removeClass(activeLightElement, `animated-lightstack-${key}`);
            void element.offsetWidth;
            this.renderer.addClass(activeLightElement, `animated-lightstack-${key}`);
          }
          else
            this.renderer.addClass(activeLightElement, `light-stack-${key}`);
        }
      }
    }
  }

  private updateLights(pos, overlay:any, element:HTMLElement){
    const isLightStack = overlay.displayOption == 'light-stack' ? true : false;
    const isActiveLight = overlay.displayOption == 'dot' ? true : false;

    if(isLightStack){
      this.updateLightStack(pos, overlay, element);
    }else if (isActiveLight){
      this.updateActiveLight(pos, overlay, element);
    }else{
      //do nothing
    }
  }

  public update(){
    if (this.imageRef && this.imageRefTarget){
      for (let obj of this.overlayConfig) {
        obj.startX = obj.x;
        obj.startY = obj.y;                                                                                                      
      }
    }
  }

  public updateByPointSelect(){
    if (this.imageRef && this.imageRefTarget){
      let obj = this.overlayConfig[0];
        const startX = obj.x;
        const startY = obj.y;
        obj.startX = startX;
        obj.startY = startY;                                                                                                      
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.showImage();
  }

  ngOnInit(): void {
    this.buildLights();
  }

  ngAfterViewInit() {
    this.showImage();
  }

  public getElapsedTime(overlay:any){
    const elapsedTime = this.elapsedTimeService.getDisplayElapsedTime(overlay.timeStamp);
    return elapsedTime;
  }

  private buildLights(){
    //filter the config object properties by colourRangeType
    if(!this.overlayConfig) return;
    for (let i = 0; i < this.overlayConfig.length; i++) {
      const overlay = this.overlayConfig[i];
      const overlayPropList:any[] = []

      if (overlay && overlay.value){
        const colourRanges =  Object.keys(overlay).reduce((obj:any, key:any) => {
          obj[key] = overlay[key];
          return obj;
        }, {});

        for (const key in colourRanges) {
            if (colourRanges.hasOwnProperty(key)) {
                const obj:any = colourRanges[key]
                overlayPropList.push({'type': key, obj:obj});// , 'min': obj.min, 'max': obj.max});
            }
        }

        this.overlayLightMap.set(i, overlayPropList);
      }
    }
  }

  public checkOffScreen(parentUnit, childUnit):any{
    const childTop = childUnit.y / childUnit.top;
    const parentTop = parentUnit.y / parentUnit.top;

    const childLeft = childUnit.x / childUnit.left;
    const parentLeft = parentUnit.x / parentUnit.left;

    const isBottomOff = childUnit.bottom > parentUnit.bottom ? true : false;
    const isTopOff = childTop < parentTop ? true : false;
    const isLeftOff = childLeft < parentLeft ? true : false;
    const isRightOff = childUnit.right > parentUnit.right ? true : false;

    const offScreenResultObj = {
        isBottomOff: isBottomOff,
        isTopOff: isTopOff,
        isLeftOff: isLeftOff,
        isRightOff: isRightOff
    }
    return offScreenResultObj;
  }

  public selectObject(object){
    if (this.objectSelected){
      this.objectSelected.emit(object);
    }
  }

  public showImage(forceShow: boolean = true) {
    if (forceShow){
      this.showImg = true;
    }
    if (this.sourceImage){
      const img = this.sourceImage.nativeElement;
      if (this.overlayConfig) {
        img.onload = (i: any) => {
          this.imageRef = i;
          this.imageRefTarget = i.target;
          this.update();
        };
      
        if (this.imageUrl) {
          this.showImg = false;
          img.src = this.imageUrl;
        } else if (this.imageData) {
          if (this.imageData.startsWith('<svg')) {
            let svg = this.imageData;
            let blob = new Blob([svg], {type: 'image/svg+xml'});
            let url = URL.createObjectURL(blob);
            img.src = url;
            img.addEventListener('load', () => URL.revokeObjectURL(url), {once: true});
            this.showImg = false;
          } else {
            this.showImg = false;
            img.src = this.imageData;
          }
        } else {
          this.showImg = false;
        }
      }
    }
  }

  onPointSelect(event: any) {
    if (!this.allowPointSelection) return;
    const img = this.sourceImage.nativeElement;
    let bounds=img.getBoundingClientRect();
    var left=bounds.left;
    var top=bounds.top;
    var x = event.pageX - left;
    var y = event.pageY - top;
    var imgWidth = this.imageRefTarget.width;
    var imgHeight = this.imageRefTarget.height;
    x = x/imgWidth * 100;
    y = y/imgHeight * 100;
    this.overlayConfig[0].x = Math.round(x);
    this.overlayConfig[0].y = Math.round(y);
    this.updateByPointSelect();
  }

  
  public getStyle(overlay:any){
    if (overlay && overlay.value){
      for (var i = 0, keys = Object.keys(overlay), ii = keys.length; i < ii; i++) {
        var key = keys[i];
        var range = overlay[key];
        if (range && range.min && range.max){
          if (range.min <= overlay.value && range.max >= overlay.value) {
            return "panel panel-" + key;
          }
        }
      }
    }
    return "panel panel-white";
  }

  private hasLightStackRepositioned(itemUri:string): boolean{
    const returnVal = this.lightStackPosMap.get(itemUri);
    if(returnVal) return true;//end if it has been repositioned
    this.lightStackPosMap.set(itemUri, true);
    return false;
  }

  private repositionOverlap(stackContainer: HTMLElement, overlayContainer:HTMLElement, imgRect:any){
    let containerUnit = stackContainer.getBoundingClientRect();
    let overlayUnit = overlayContainer.getBoundingClientRect();

    const isOverlappedRight = overlayUnit.right - containerUnit.left;
    if(isOverlappedRight > 12){

      const left = (((overlayUnit.left / imgRect.right))*100).toFixed(0)  ; 
      const leftOffSet = parseInt(left) - 10;
       let leftPercent  = `${leftOffSet}%` ;
      stackContainer.style.left = leftPercent;
    }
    
  }

  private repositionLightStack(stackContainerElement: HTMLElement, imgRect: any){
      let containerUnit = stackContainerElement.getBoundingClientRect();

      const offImageMesaure = this.checkOffScreen(imgRect, containerUnit);
      //if no offscreen detected
      if(!offImageMesaure.isBottomOff && !offImageMesaure.isTopOff && !offImageMesaure.isLeftOff && !offImageMesaure.isRightOff){
        return; //skip
      }
      let hasPositioned = false;
      //fail safe to avoid endless looping
      let posCounter = 0;

      while (!hasPositioned && posCounter < 10){
        containerUnit = stackContainerElement.getBoundingClientRect();
        imgRect = this.sourceImage.nativeElement.getBoundingClientRect();
        
        let offImageMesaureObj = this.checkOffScreen(imgRect, containerUnit);

        if(offImageMesaureObj.isBottomOff || offImageMesaureObj.isTopOff || offImageMesaureObj.isLeftOff || offImageMesaureObj.isRightOff){
          if(offImageMesaureObj.isBottomOff){
            const top = stackContainerElement.style.top;
            let topInNum = parseInt(top.replace(/[^\d.-]/g, ''));
            let topUpdated  = `${topInNum - 1}%` ;
            stackContainerElement.style.top = topUpdated;
          }
          if(offImageMesaureObj.isTopOff){
            const top = stackContainerElement.style.top;
            let topInNum = parseInt(top.replace(/[^\d.-]/g, ''));
            let topUpdated  = `${topInNum + 1}%` ;
            stackContainerElement.style.top = topUpdated;
          }
          if(offImageMesaureObj.isLeftOff){
            const left = stackContainerElement.style.left;
            let leftInNum = parseInt(left.replace(/[^\d.-]/g, ''));
            let leftIncreased  = `${leftInNum + 5}%` ;
            stackContainerElement.style.left = leftIncreased;
          }
          if(offImageMesaureObj.isRightOff){
            const left = stackContainerElement.style.left;
            let leftInNum = parseInt(left.replace(/[^\d.-]/g, ''));
            let leftIncreased  = `${leftInNum - 5}%` ;
            stackContainerElement.style.left = leftIncreased;
          }
          posCounter++;
        }else{
          hasPositioned = true;
        }
      }
  }

  private getStackContainerElement(itemUri): HTMLElement{
    const stackContainerName = `stack-container-${itemUri}`;
    return document.getElementById(stackContainerName);
  }
}
